<h2 mat-dialog-draggable-title mat-dialog-title>{{'title.edit_procedure' | translate}}
  <button (click)="onNoClick()" aria-label="Close" cdkFocusInitial class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>

<mat-divider></mat-divider>

<form #f="ngForm" (ngSubmit)="!f.form.valid? accordion.openAll() : 'true' && f.form.valid && onCreateProcedure()"
      [appCheckProcedureNamePrefix]="[procedureNamePrefix]" [appCheckProcedureName]="['procedureName']" appFocusFirstElement
      name="form">

  <mat-dialog-content>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel class="mt-3" expanded=true>
        <mat-expansion-panel-header class="pt-2">
          <mat-panel-title class="mat-panel-title justify-content-between">
            <span>{{'title.procedure_info' | translate}}</span>
            <small class="form-text text-gray">(<span style="color: red;">*</span>) {{'form.info' |
              translate}}</small>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
          <!-- Nhập tên quy trình -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input #focusInput #procedureName="ngModel" #procedureNameRef
                     #todo (focusout)="procedure.procedureName = procedure.procedureName.trim()" [(ngModel)]="procedure.procedureName"
                     [placeholder]="'placeholder.procedure_name' | translate" autocomplete="off"
                     id="procedureName" matInput maxlength="200"
                     name="procedureName" required type="text"/>
              <button (click)="procedure.procedureName=procedureNamePrefix" *ngIf="procedure.procedureName" aria-label="Clear" mat-button mat-icon-button
                      matSuffix type="button">
                <mat-icon>close</mat-icon>
              </button>
              <mat-error *ngIf="f.submitted || procedureName.invalid">
                                <span *ngIf="procedureName?.errors?.required" class="text-error">
                                    {{'validation.procedureName' | translate}}
                                </span>
                <span *ngIf="procedureName?.errors?.duplicate" class="text-error">
                                    {{'validation.err_procedure_name_duplicate' | translate}}
                                </span>
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Loai quy trinh -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <mat-select [(ngModel)]="procedure.type" [placeholder]="'placeholder.procedure_type' | translate" id="type"
                          name="type" name="type" required>
                <mat-option (click)="onProcedureTypeChange(true, true)" value="1">
                  {{ 'title.procedure_full' | translate}}
                </mat-option>

                <mat-option (click)="onProcedureTypeChange(false, true)" value="2">
                  {{ 'title.procedure_internal' | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>
        <div class="row">
          <!-- Mo ta quy trinh -->
          <div class="col-sm-12">
            <mat-form-field class="mat-full-width">
              <input #description="ngModel"
                     (focusout)="procedure.description = procedure.description.trim()" [(ngModel)]="procedure.description" [placeholder]="'placeholder.procedure_desc' | translate" autocomplete="off"
                     id="description" matInput
                     maxlength="200" name="description" type="text"/>
              <button (click)="procedure.description=''" *ngIf="procedure.description" aria-label="Clear" mat-button mat-icon-button
                      matSuffix type="button">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <!-- active or not
          <div class="col-sm-3">
              <mat-form-field class="mat-full-width">
                  <mat-select id="status" name="status" [placeholder]="'placeholder.procedure_status' | translate"
                      name="status" [(ngModel)]="procedure.status" #type="ngModel" required>
                      <mat-option value="0">
                          {{ 'title.procedure_inactive' | translate}}
                      </mat-option>

                      <mat-option value="1">
                          {{ 'title.procedure_active' | translate }}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
          </div> -->

        </div>
      </mat-expansion-panel>

      <div *ngIf="this.isFullProcedure != null">

        <mat-expansion-panel *ngIf="this.isFullProcedure" class="mat-elevation-z0" expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "form.contracting_parties" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="note2">
            <div class="note-title">
                {{ "form.note_sign" | translate }}
            </div>
        
            <div class="note-item">
                {{ "form.note_sign_2" | translate }}
            </div>
        
            <div class="note-item">
                {{ "form.note_sign_3" | translate }}
            </div>
        </div>
          <!-- Nz-table set luồng chủ thể -->
          <!-- <form nz-form> -->
          <!-- <span class="float-right" *ngIf="this.valueSelect == '0' ">
      {{'enterprise_contract.panel_document.table_parties.guide_checkbox' | translate}}</span> -->
          <nz-table #partyRowTable [nzData]="RECORD_PARTY_SIGN" [nzFrontPagination]="false" [nzShowPagination]="false"
                    class="ant-table-no-placeholder-border-bottom no-ant-table-placeholder" style="margin-bottom: 6px;"
                    nzBordered>
            <thead>
            <tr>
              <th class="text-center" nzWidth="55px">
                {{
                "enterprise_contract.panel_document.table_parties.header.order"
                  | translate
                }}
              </th>
              <th class="text-center">
                {{
                "enterprise_contract.panel_document.table_parties.header.party_name"
                  | translate
                }}
              </th>
              <th class="text-center" nzWidth="30%">
                {{
                "enterprise_contract.panel_document.table_parties.header.email"
                  | translate
                }}
              </th>
              <th class="text-center" nzWidth="18%" colspan="2" *ngIf="!isNotAttestedUser">
                {{
                "enterprise_contract.panel_document.table_parties.header.phone"
                  | translate
                }}
              </th>
              <th class="text-center" nzWidth="18%"  *ngIf="isNotAttestedUser">
                {{
                "enterprise_contract.panel_document.table_parties.header.phone"
                  | translate
                }}
              </th>
<!--              <th nzWidth="25px" *ngIf="!isNotAttestedUser">-->
<!--                {{-->
<!--                "enterprise_contract.panel_document.table_parties.header.sign_no_login"-->
<!--                  | translate-->
<!--                }}-->
<!--              </th>-->
              <th *ngIf="this.valueSelect == '0'" nzWidth="25px">
                {{
                "enterprise_contract.panel_document.table_parties.header.insert_infor"
                  | translate
                }}
              </th>
              <!-- Nếu chọn lập từ mẫu thì hiển thị cột chọn khách hàng để fill thông tin vào template-->
              <th nzWidth="34px"><div style="min-width: 34px;"></div></th>
            </tr>
            </thead>
            <tbody *ngFor="let data of partyRowTable.data">
            <tr class="editable-row">
              <!-- TT -->
              <td class="text-center" rowspan="2" *ngIf="!data.isCreatedSide">
                <nz-input-number (ngModelChange)="onChangeOrderOfPartySign()" [(ngModel)]="data.order" [ngModelOptions]="{ standalone: true }"
                                 [nzMin]="1"
                                 class="td-nz-input">
                </nz-input-number>
              </td>
              <td class="text-center" *ngIf="data.isCreatedSide">
                <nz-input-number (ngModelChange)="onChangeOrderOfPartySign()" [(ngModel)]="data.order" [ngModelOptions]="{ standalone: true }"
                                 [nzMin]="1"
                                 class="td-nz-input">
                </nz-input-number>
              </td>
              <!-- Tên -->
              <td class="word-break-line">
                {{ data.name }}
              </td>
              <!-- Email -->
              <td class="word-break-line">
                <div *ngIf="data.isCreatedSide">{{ data.email }}</div>
                <div *ngIf="!data.isCreatedSide">
                  <nz-form-item class="nz-form-item-customize">
                    <nz-form-control nzHasFeedback>
                      <input (keydown)="checkFormChanging()" (ngModelChange)="onChangeEnterpriseValue('email', data)" [(ngModel)]="data.email"
                             [ngModelOptions]="{ standalone: true }"
                             [pattern]="emailPattern"
                             nz-input placeholder="{{ 'placeholder.email' | translate }}"
                             [required]="scopeType == 1"
                             />
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </td>

              <!-- Phone -->
              <td class="word-break-line" colspan="2" *ngIf="!isNotAttestedUser">
                <div *ngIf="data.isCreatedSide">{{ data.phone }}</div>
                <div *ngIf="!data.isCreatedSide">
                  <nz-form-item class="nz-form-item-customize">
                    <nz-form-control nzHasFeedback>
                      <input (keydown)="checkFormChanging()" (ngModelChange)="onChangeEnterpriseValue('phone', data)" [(ngModel)]="data.phone"
                             [ngModelOptions]="{ standalone: true }"
                             [pattern]="phonePattern2" [maxlength]="phoneMaxlength2"
                             nz-input required/>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </td>
              <td class="word-break-line"  *ngIf="isNotAttestedUser">
                <div *ngIf="data.isCreatedSide">{{ data.phone }}</div>
                <div *ngIf="!data.isCreatedSide">
                  <nz-form-item class="nz-form-item-customize">
                    <nz-form-control nzHasFeedback>
                      <input (keydown)="checkFormChanging()" (ngModelChange)="onChangeEnterpriseValue('phone', data)" [(ngModel)]="data.phone"
                             [ngModelOptions]="{ standalone: true }"
                             [pattern]="phonePattern2" [maxlength]="phoneMaxlength2"
                             nz-input required/>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </td>
<!--              <td class="text-center" *ngIf="!isNotAttestedUser">-->
<!--                <label (ngModelChange)="-->
<!--                                        onSelectCustomerForTemplate(-->
<!--                                            data.customerId,-->
<!--                                            data.useDataForTemplate-->
<!--                                        )-->
<!--                                        " *ngIf="!data.isCreatedSide"-->
<!--                       [(ngModel)]="data.isSignNoLogin" [ngModelOptions]="{ standalone: true }"-->
<!--                       nz-checkbox></label>-->
<!--              </td>-->
              <td class="text-center" rowspan="2" *ngIf="!data.isCreatedSide">
                <div class="d-flex">
                  <a (nzOnConfirm)="
                                onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)
                                " [nzIcon]="iconDel" class="text-center" nz-popconfirm nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}"
                     nzPopconfirmTitle="{{
                                'popup.confirm_delete_party' | translate
                                }}">
                    <!-- <i class="nz-icon-font" nz-icon nzType="close-square" nzTheme="outline" nz-tooltip
nzTitle="{{ 'tooltips.delete' | translate }}"></i> -->
                    <i aria-hidden="true" class="fa fa-trash"
                       matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                  </a>
                  <ng-template #iconDel>
                    <i class="text-primary" nz-icon nzTheme="outline" nzType="warning"></i>
                  </ng-template>
                  <a (click)="isShowUserSignTable = !isShowUserSignTable"
                     *ngIf="data.isCreatedSide" [ngStyle]="{'transform': !isShowUserSignTable ? 'rotate(0deg)' : 'rotate(180deg)'}"
                     style="transition: 0.3s; margin-left: 7px; display: flex; align-items: center;">
                    <i aria-hidden="true" class="fa fa-angle-down" matTooltip="{{ (isShowUserSignTable ? 'tooltips.hidden' : 'tooltips.show') | translate }}"
                       nzIcon
                       style="font-size: 17px;"></i>
                  </a>
                </div>
              </td>
              <td class="text-center" *ngIf="data.isCreatedSide">
                <div class="d-flex">
                  <a (nzOnConfirm)="
                                onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)
                                " [nzIcon]="iconDel" class="text-center" nz-popconfirm nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}"
                     nzPopconfirmTitle="{{
                                'popup.confirm_delete_party' | translate
                                }}">
                    <!-- <i class="nz-icon-font" nz-icon nzType="close-square" nzTheme="outline" nz-tooltip
nzTitle="{{ 'tooltips.delete' | translate }}"></i> -->
                    <i aria-hidden="true" class="fa fa-trash"
                       matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                  </a>
                  <ng-template #iconDel>
                    <i class="text-primary" nz-icon nzTheme="outline" nzType="warning"></i>
                  </ng-template>
                  <a (click)="isShowUserSignTable = !isShowUserSignTable"
                     *ngIf="data.isCreatedSide" [ngStyle]="{'transform': !isShowUserSignTable ? 'rotate(0deg)' : 'rotate(180deg)'}"
                     style="transition: 0.3s; margin-left: 7px; display: flex; align-items: center;">
                    <i aria-hidden="true" class="fa fa-angle-down" matTooltip="{{ (isShowUserSignTable ? 'tooltips.hidden' : 'tooltips.show') | translate }}"
                       nzIcon
                       style="font-size: 17px;"></i>
                  </a>
                </div>
              </td>
            </tr>
            <tr *ngIf="!data.isCreatedSide">
              <td colspan="4" *ngIf="!isNotAttestedUser">
                <label (ngModelChange)="
                                                        onSelectCustomerForTemplate(
                                                            data.customerId,
                                                            data.useDataForTemplate
                                                        )
                                                        " *ngIf="!data.isCreatedSide && !isNotAttestedUser"
                       [(ngModel)]="data.isSignNoLogin" [ngModelOptions]="{ standalone: true }" style="color:rgba(0, 0, 0, 0.87) !important; "
                       nz-checkbox>{{'enterprise_contract.panel_document.table_parties.header.SNL' | translate}}</label>
                <label (ngModelChange)="changeChanKy(data)" *ngIf="!data.isCreatedSide && data.customerType !== 10000"
                       [(ngModel)]="data.signConfig" [ngModelOptions]="{ standalone: true }" style="color:rgba(0, 0, 0, 0.87) !important; "
                       nz-checkbox>{{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label>
              </td>
              <td colspan="3" *ngIf="isNotAttestedUser && data.customerType!==10000">
                <label (ngModelChange)="
                                                        onSelectCustomerForTemplate(
                                                            data.customerId,
                                                            data.useDataForTemplate
                                                        )
                                                        " *ngIf="!data.isCreatedSide && !isNotAttestedUser"
                       [(ngModel)]="data.isSignNoLogin" [ngModelOptions]="{ standalone: true }" style="color:rgba(0, 0, 0, 0.87) !important; "
                       nz-checkbox>{{'enterprise_contract.panel_document.table_parties.header.SNL' | translate}}</label>
                <label (ngModelChange)="changeChanKy(data)" *ngIf="!data.isCreatedSide && data.customerType !== 10000"
                       [(ngModel)]="data.signConfig" [ngModelOptions]="{ standalone: true }" style="color:rgba(0, 0, 0, 0.87) !important; "
                       nz-checkbox>{{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label>
              </td>
            </tr>
            <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
              <td
                [attr.rowspan]="(isValidNoUserExist || isValidExistingSigning) ?
                RECORD_USER_PERFORM_SIGN.length + 7
                : RECORD_USER_PERFORM_SIGN.length + 6"
                >
              </td>
              <td [attr.colspan]="setColspan(6)" style="padding: 0 !important;">
                  <div class="mat-panel-title mat-panel-title_custom font-color-blue">
                      {{ "form.order_of_approval_signing_contract_unit" | translate }}
                  </div>
                <!-- Nz-table set luồng ký / duyệt-->

                <!-- End Nz-table set luồng ký / duyệt-->
              </td>
            </tr>

            <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable"
            style="background: #fafafa;" class="text-primary"
            >
            <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
              <div class="d-flex">
                <div class="title">
                  {{
                  "enterprise_contract.panel_document.table_users.header.order"
                  | translate
                  }}
                </div>
                <div class="d-flex justify-content-center" style="width: 100%; align-items: center;">
                  {{
                  "enterprise_contract.panel_document.table_users.header.name"
                  | translate
                  }}
                </div>
              </div>
            </td>
            <td></td>
            </tr>
            <!-- Người dùng phê duyệt hợp đồng -->
            <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
              <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
                <div class="d-flex align-items-center">
                  <div class="col-8 w-100 mat-panel-title_custom font-color-blue" style="padding-left: 10px;">
                      {{ "form.contract_approver" | translate}} &nbsp;
                  </div>
                  <div class="col-2 text-center mat-panel-title_custom font-color-blue d-flex justify-content-center"
                         style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                      {{"enterprise_contract.panel_document.table_parties.header.sig_cts" | translate}}
                  </div>
                  <div class="col-2 text-center mat-panel-title_custom font-color-blue d-flex justify-content-center"
                      style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                      {{"enterprise_contract.panel_document.table_parties.header.display_signature" | translate}}
                  </div>
                </div>
              </td>
          <td></td>
            </tr>

            <!-- Danh sách người dùng phê đuuyệt hợp đồng -->
            <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
              [hidden]="!(showTableMembers && data.isCreatedSide && isShowUserSignTable) || !(user.role !== '1' && data.isCreatedSide)">
              <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
                <div class="d-flex">
                  <div class="col-8 d-flex" style="padding-left: 0;">
                    <div class="col-2" style="padding: 15px 0; border-right: 1px solid #d9d9d9; max-width: 80px;">
                      <nz-input-number class="td-nz-input" style="max-width: 60px;" [(ngModel)]="user.order" (ngModelChange)="onChangeOrderApproveSign()" [nzMin]="1"
                      [ngModelOptions]="{ standalone: true }"></nz-input-number> </div>
                    <div class="d-flex col-10" style="align-items: center; padding: 0 8px">
                          <div class="editable-cell" *ngIf="user.userId != null">
                            <div *ngIf="user.departmentName" class="row-icon department"><span
                                class="material-icons">apartment</span>{{ user.departmentName }}</div>
                            <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                              {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div>
                          </div>
                    </div>
                  </div>
                  <div class="col-2 d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                    <label nz-checkbox [(ngModel)]="user.isSignDigitalCertificate"
                           (ngModelChange)="user.isSignDigitalCertificate ? user.signConfig.showImage = true : user.signConfig.showImage = false;"
                           [ngModelOptions]="{ standalone: true }">
                    </label>
                  </div>
                  <div class="col-2 d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                    <ng-container *ngIf="user && user.isSignDigitalCertificate">
                      <label nz-checkbox [ngModel]="user?.signConfig?.showImage" (ngModelChange)="user.signConfig.showImage = $event"
                        [ngModelOptions]="{ standalone: true }">
                      </label>
                    </ng-container>
                  </div>
              </div>
              </td>
              <td class="text-center">
                <a *ngIf="user.userId != null" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
            'popup.confirm_delete_user' | translate
          }}" (nzOnConfirm)="onClickDeleteElementRecordUser(user.userId)"
                  nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                  <!-- <i class="nz-icon-font" nz-icon nzType="close-square" nzTheme="outline" nz-tooltip
  nzTitle="{{ 'tooltips.delete' | translate }}"></i> -->
                  <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                </a>
                <ng-template #iconDel>
                  <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                </ng-template>
              </td>
            </tr>

            <!-- Tìm kiếm người dùng phê duyệt hợp đồng -->
            <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable && !isCheckApprover">
              <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
                <div class="d-flex">
                  <div class="col-8 d-flex" style="padding-left: 0;">
                    <div style="width: 86px; max-width: 86px; padding: 15px 20px; border-right: 1px solid #d9d9d9;">
                    </div>
                    <div class="d-flex justify-content-center"
                      style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                      <div class="w-100">
                        <nz-input-group [nzSuffix]="suffixUserInput">
                            <input nz-input [(ngModel)]="inputUserValue"
                                (input)="onChangeUserSearch($event)"
                                [nzAutocomplete]="autoUserSearching"
                                [ngModelOptions]="{ standalone: true }"
                                placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}"
                                #autocompleteInput id="inputUser" />
                            <nz-autocomplete #autoUserSearching>
                                <nz-auto-option *ngFor="let user of filteredUserOptions"
                                    (selectionChange)="autocompleteUserSelected($event, user)"
                                    [nzValue]="''">{{ user.name }}
                                    <span *ngIf="user.email">- {{ user.email }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></nz-auto-option>
                            </nz-autocomplete>
                        </nz-input-group>
                        <ng-template #suffixUserInput>
                            <nz-spin *ngIf="nzCheckLoadingUser" nzSimple
                                [nzIndicator]="indicatorUserInput"></nz-spin>
                        </ng-template>
                        <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon
                                nzType="loading" style="font-size: 24px"></i></ng-template>
                    </div>
                    </div>
                </div>
                  <div class="d-flex col-2" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;"></div>
                  <div class="d-flex col-2" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;"></div>
                </div>
              </td>
              <td></td>
            </tr>

            <!-- Người dùng Ký duyệt hợp đồng -->
            <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable">
              <td [attr.colspan]="setColspan(6)" style="padding: 0 !important;">
                <div class="mat-panel-title_custom font-color-blue" style="padding-left: 10px">
                  {{ "form.user_signs_and_approves_the_contract" | translate}}
                </div>
              </td>
            </tr>

            <!-- Danh sách người dùng Ký đuuyệt hợp đồng -->
            <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
              [hidden]="!(showTableMembers && data.isCreatedSide && isShowUserSignTable) || !(user.role === '1' && data.isCreatedSide)">
              <td class="text-center" [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
                <div class="d-flex">
                  <div style="width: 86px; max-width: 86px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                    1
                  </div>
                  <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                    <div class="editable-cell" *ngIf="user.userId != null">
                      <div *ngIf="user.departmentName" class="row-icon department"><span
                          class="material-icons">apartment</span>{{ user.departmentName }}</div>
                      <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                        {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div>
                    </div>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <a *ngIf="user.userId != null" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
            'popup.confirm_delete_user' | translate
          }}" (nzOnConfirm)="onClickDeleteElementRecordUser(user.userId)"
                  nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                  <!-- <i class="nz-icon-font" nz-icon nzType="close-square" nzTheme="outline" nz-tooltip
  nzTitle="{{ 'tooltips.delete' | translate }}"></i> -->
                  <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                </a>
                <ng-template #iconDel>
                  <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                </ng-template>
              </td>
            </tr>

            <!-- Tìm kiếm người dùng Ký duyệt hợp đồng -->
            <tr *ngIf="showTableMembers && data.isCreatedSide && isShowUserSignTable && !isUserSign">
              <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
                <div class="d-flex">
                  <div style="width: 86px; max-width: 86px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                  </div>
                  <div class="d-flex justify-content-center"
                    style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                    <div class="w-100">
                      <nz-input-group [nzSuffix]="suffixUserInput">
                          <input nz-input [(ngModel)]="inputUserSignValue"
                              (input)="onChangeUserSignSearch($event)"
                              [nzAutocomplete]="autoUserSignSearching"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}"
                              #autocompleteInput id="inputUser" />
                          <nz-autocomplete #autoUserSignSearching>
                              <nz-auto-option *ngFor="let user of filteredUserOptions"
                                  (selectionChange)="autocompleteUserSignSelected($event, user)"
                                  [nzValue]="''">{{ user.name }}
                                  <span *ngIf="user.email">- {{ user.email }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></nz-auto-option>
                          </nz-autocomplete>
                      </nz-input-group>
                      <ng-template #suffixUserInput>
                          <nz-spin *ngIf="nzCheckLoadingUserSign" nzSimple
                              [nzIndicator]="indicatorUserInput"></nz-spin>
                      </ng-template>
                      <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon
                              nzType="loading" style="font-size: 24px"></i></ng-template>
                  </div>
                  </div>
                </div>
              </td>
              <td></td>
            </tr>

            <tr
              *ngIf="(isValidNoUserExist || isValidExistingSigning) && data.isCreatedSide && isShowUserSignTable && !isUserSign">
              <td [attr.colspan]="setColspan(5)">
                <mat-error class="font-weight-bold" *ngIf="isValidNoUserExist || isValidExistingSigning"
                  style="padding-top: 0.5rem">
                  {{ "validation.error_user_no_set_up" | translate }}
                </mat-error>
              </td>
            </tr>

      </tbody>
      <tbody>
      <tr class="editable-row">
        <!-- TT -->
        <td class="text-center">
          <nz-input-number [(ngModel)]="valueAddPartyOrder" [ngModelOptions]="{ standalone: true }" [nzMin]="1"
                           class="td-nz-input"></nz-input-number>
        </td>
        <!-- Tên -->
        <td colspan="3">
          <div>
            <nz-input-group [nzSuffix]="suffixPartyInput">
              <input #focusPartyInput (input)="onChangePartySignSearch($event)" [(ngModel)]="inputPartyValue"
                     [ngModelOptions]="{ standalone: true }" [nzAutocomplete]="autoPartySearching"
                     id="inputParty" nz-input placeholder="{{
                                    'placeholder.input_paperNumber' | translate
                                    }}"/>
              <nz-autocomplete #autoPartySearching>
                <nz-auto-option (selectionChange)="
                                        autocompletePartySelected($event, party)
                                    " *ngFor="let party of filteredPartyOptions" [nzValue]="''">
                  <div class="d-flex">
                    <mat-icon class="mr-2">account_circle</mat-icon>
                    <span style="line-height: 20px">
                                                {{ party.name }} -
                      {{
                      party.taxCode && party.taxCode.length > 0
                        ? party.taxCode
                        : party.certificateNo
                      }}
                                            </span>
                  </div>
                  <div class="d-flex">
                    <mat-icon class="mr-2">contact_mail</mat-icon>
                    <span style="line-height: 20px">
                      <span *ngIf="party.email">{{ party.email }} -</span>
                      {{ party.phone }}
                                            </span>
                  </div>
                  <hr style="margin: 0; padding: 0"/>
                </nz-auto-option>
              </nz-autocomplete>
            </nz-input-group>
            <ng-template #suffixPartyInput>
              <i (click)="openAddCustomer()" *ngIf="!nzCheckLoadingParty && !isFromSSO && checkDisplayBtnAddCustomer()" class="nz-icon-font" nz-icon nz-tooltip nzTheme="outline" nzTitle="{{
                                    'enterprise_contract.tooltips.icon_add_new_customer'
                                        | translate
                                    }}"
                 nzType="plus-circle">
              </i>
              <nz-spin *ngIf="nzCheckLoadingParty" [nzIndicator]="indicatorPartyInput" nzSimple>
              </nz-spin>
            </ng-template>
            <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                 style="font-size: 24px"></i></ng-template>
          </div>
        </td>
        <td *ngIf="this.valueSelect == '0'">&nbsp;</td>
        <td *ngIf="!isNotAttestedUser">&nbsp;</td>
        <td></td>
      </tr>
      <!-- nút thêm lại công ty nội bộ -->
      <tr *ngIf="checkShowBtnAddEnterpriseEnt()">
        <td></td>
        <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
          <div class="mat-panel-title mat-panel-title_custom font-color-blue" style="padding-left: 10px">
            {{ "form.add_create_sign" | translate }} &nbsp;
            <div class="d-flex">
              <mat-icon class="mr-0 text-primary" style=" font-size: x-large; cursor: pointer"
                        (click)="comBack()">add_circle_outline
              </mat-icon>
            </div>
          </div>
        </td>
        <td></td>
      </tr>
      </tbody>
      </nz-table>
      <mat-error *ngIf="isInvalidPartyOrder" class="font-weight-bold">
        Vui lòng xem kiểm tra lại dữ liệu, "Thứ tự ký" phải liên tiếp
      </mat-error>
      <mat-error *ngIf="isInvalidSetPartyFlow" class="font-weight-bold">
        {{ "validation.error_enterprise_no_set_up" | translate }}
      </mat-error>
      <mat-error class="font-weight-bold" *ngIf="isEmailInvalid && !isPhoneInvalid">
      {{ "validation.error_email_format" | translate }}
      </mat-error>
      <mat-error class="font-weight-bold" *ngIf="!isEmailInvalid && isPhoneInvalid">
      {{ "validation.phone_format_upgrade" | translate }}
      </mat-error>
      <mat-error class="font-weight-bold" *ngIf="isEmailInvalid && isPhoneInvalid">
      {{ "validation.error_email_phone_format" | translate }}
      </mat-error>
      <!-- </form> -->
<!--      <span class="span-guiding" *ngIf="!isNotAttestedUser"><b>{{-->
<!--        "enterprise_contract.panel_document.table_parties.header.sign_no_login"-->
<!--          | translate-->
<!--        }}</b>:-->
<!--        {{-->
<!--        "enterprise_contract.panel_document.table_parties.guide_sign_no_login"-->
<!--          | translate-->
<!--        }}</span>-->
      <span *ngIf="this.valueSelect == '0'" class="span-guiding"><b>{{
        "enterprise_contract.panel_document.table_parties.header.insert_infor"
          | translate
        }}</b>:
        {{
        "enterprise_contract.panel_document.table_parties.guide_insert_infor"
          | translate
        }}</span>
      <!-- End of Nz-table set chu the-->
      </mat-expansion-panel>

      <hr/>

      <!-- Nz-table set luồng ký / duyệt-->
      <mat-expansion-panel *ngIf="showTableMembers && !this.isFullProcedure" class="mat-elevation-z0"
                           expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title font-color-blue">
            {{ "form.order_of_approval_signing_contract_unit" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- <form nz-form> -->
        <nz-table #editRowTable [nzData]="RECORD_USER_PERFORM_SIGN" [nzFrontPagination]="false" [nzShowPagination]="false"
                  class="ant-table-no-placeholder-border-bottom" nzBordered>
          <thead>
            <tr>
              <th class="text-center" nzWidth="50px">
                  {{
                  "enterprise_contract.panel_document.table_users.header.order"
                  | translate
                  }}
              </th>
              <th class="text-center" nzWidth="100%">
                  {{
                  "enterprise_contract.panel_document.table_users.header.name"
                  | translate
                  }}
              </th>
              <th nzWidth="50px">&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <!-- Người dùng phê duyệt hợp đồng -->
          <tr>
            <td [attr.colspan]="setColspan(3)" style="padding: 0 !important;">
              <div class="d-flex align-items-center">
                <div class="col-8 w-100 mat-panel-title_custom font-color-blue" style="padding-left: 10px;">
                  {{ "form.contract_approver" | translate}} &nbsp;
                </div>
                <div class="col-2 text-center mat-panel-title_custom font-color-blue d-flex justify-content-center title-user-approver">
                  {{"enterprise_contract.panel_document.table_parties.header.sig_cts" | translate}}
                </div>
                <div class="col-2 text-center mat-panel-title_custom font-color-blue d-flex justify-content-center title-user-approver">
                  {{"enterprise_contract.panel_document.table_parties.header.display_signature" | translate}}
                </div>
              </div>
            </td>
          <td></td>
          </tr>
          </tbody>
          <tbody *ngFor="let data of editRowTable.data; let i = index">
          <tr *ngIf="data.role !== '1'" class="editable-row">
            <td class="text-center" class="text-center" [attr.colspan]="setColspan(3)" style="padding: 0 !important;">
              <div class="d-flex">
                <div class="col-8 d-flex" style="padding-left: 0;">
                  <div class="col-2" style="padding: 15px 0; border-right: 1px solid #d9d9d9; max-width: 80px;">
                    <nz-input-number class="td-nz-input" style="max-width: 60px;" [(ngModel)]="data.order" (ngModelChange)="onChangeOrderApproveSign()" [nzMin]="1"
                    [ngModelOptions]="{ standalone: true }"></nz-input-number> </div>
                  <div class="d-flex col-10" style="align-items: center; padding: 0 8px">
                        <div class="editable-cell" *ngIf="data.userId != null">
                          <div *ngIf="data.departmentName" class="row-icon department"><span
                              class="material-icons">apartment</span>{{ data.departmentName }}</div>
                          <div class="row-icon"><span class="material-icons" *ngIf="!data.departmentName">person</span>
                            {{data.name}} <span *ngIf="data.email">- {{data.email}}</span> <span *ngIf="data.userPosition"> - {{data.userPosition}}</span></div>
                        </div>
                  </div>
                </div>
                <div class="col-2 d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                  <label nz-checkbox [(ngModel)]="data.isSignDigitalCertificate"
                         (ngModelChange)="data.isSignDigitalCertificate ? data.signConfig.showImage = true : data.signConfig.showImage = false;"
                         [ngModelOptions]="{ standalone: true }">
                  </label>
                </div>
                <div class="col-2 d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                  <ng-container *ngIf="data && data.isSignDigitalCertificate">
                    <label nz-checkbox [ngModel]="data?.signConfig?.showImage"
                      (ngModelChange)="data.signConfig.showImage = $event;"
                      [ngModelOptions]="{ standalone: true }">
                    </label>
                  </ng-container>
                </div>
              </div>
            </td>
            <!-- Action -->
            <td class="td-nz-icon text-center">
              <a (nzOnConfirm)="onClickDeleteElementRecordUser(data.userId)" *ngIf="data.userId != null" [nzIcon]="iconDel" nz-popconfirm nzCancelText="{{ 'button.cancel' | translate }}"
                 nzOkText="{{ 'button.ok' | translate }}"
                 nzPopconfirmTitle="{{
        'popup.confirm_delete_user' | translate
        }}">
                <!-- <i class="nz-icon-font" nz-icon nzType="close-square" nzTheme="outline" nz-tooltip
nzTitle="{{ 'tooltips.delete' | translate }}"></i> -->
                <i aria-hidden="true" class="fa fa-trash"
                   matTooltip="{{ 'tooltips.delete' | translate }}"></i>
              </a>
              <ng-template #iconDel>
                <i class="text-primary" nz-icon nzTheme="outline" nzType="warning"></i>
              </ng-template>
            </td>
          </tr>
          </tbody>
          <tbody>
          <tr class="editable-row" *ngIf="!isCheckApprover">
            <td colspan="2" style="padding: 0 !important;">
              <div class="d-flex">
                <div class="col-8 d-flex" style="padding-left: 0;">
                  <div style="width: 88px; max-width: 88px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                  </div>
                  <div class="d-flex justify-content-center"
                      style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                      <div style="width: 100%;">
                          <nz-input-group [nzSuffix]="suffixUserInput">
                              <input nz-input [(ngModel)]="inputUserValue"
                                  (input)="onChangeUserSearch($event)" [nzAutocomplete]="autoUserSearching"
                                  [ngModelOptions]="{ standalone: true }"
                                  placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}"
                                  #autocompleteInput id="inputUser" />
                              <nz-autocomplete #autoUserSearching>
                                  <nz-auto-option *ngFor="let user of filteredUserOptions"
                                      (selectionChange)="autocompleteUserSelected($event, user)"
                                      [nzValue]="''">{{ user.name }}
                                      <span *ngIf="user.email">- {{ user.email }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></nz-auto-option>
                              </nz-autocomplete>
                          </nz-input-group>
                          <ng-template #suffixUserInput>
                              <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput">
                              </nz-spin>
                          </ng-template>
                          <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                  style="font-size: 24px"></i></ng-template>
                      </div>
                  </div>
              </div>
                  <div class="d-flex col-2" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;"></div>
                  <div class="d-flex col-2" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;"></div>
              </div>
          </td>
          <td></td>
          </tr>
          </tbody>

          <tbody>
          <!-- Người dùng ký duyệt hợp đồng -->
          <tr>
            <td colspan="3">
              <div style="padding-left: 10px; color: #4e73df; font-style: italic;">
                  {{ "form.user_signs_and_approves_the_contract" | translate}} &nbsp;
              </div>
            </td>
          </tr>
          </tbody>
          <tbody *ngFor="let data of editRowTable.data; let i = index">
            <tr class="editable-row" *ngIf="data.role === '1'">
              <td class="text-center" colspan="2" style="padding: 0 !important;">
                  <div class="d-flex">
                      <div style="width: 85px; max-width: 85px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                          1
                      </div>
                      <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                          <div class="editable-cell" *ngIf="data.userId != null">
                              <div *ngIf="data.departmentName" class="row-icon department"><span
                                      class="material-icons">apartment</span>{{ data.departmentName }}</div>
                              <div class="row-icon word-break-line text-left"><span class="material-icons"
                                      *ngIf="!data.departmentName">person</span>
                                  {{data.name}} <span *ngIf="data.email">- {{data.email}}</span> <span *ngIf="data.userPosition"> - {{data.userPosition}}</span></div>
                          </div>
                      </div>
                  </div>
              </td>

              <!-- Action -->
              <td class="td-nz-icon text-center">
                  <a *ngIf="data.userId != null" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
'popup.confirm_delete_user' | translate
}}" (nzOnConfirm)="onClickDeleteElementRecordUser(data.userId)" nzCancelText="{{ 'button.cancel' | translate }}"
                      nzOkText="{{ 'button.ok' | translate }}">
                      <!-- <i class="nz-icon-font" nz-icon nzType="close-square" nzTheme="outline" nz-tooltip
nzTitle="{{ 'tooltips.delete' | translate }}"></i> -->
                      <i class="fa fa-trash" aria-hidden="true"
                          matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                  </a>
                  <ng-template #iconDel>
                      <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                  </ng-template>
              </td>
          </tr>
          </tbody>

          <!-- Tìm kiếm người dùng ký duyệt hợp đồng -->
          <tbody *ngIf="!isUserSign">
            <tr class="editable-row">
              <td colspan="2" style="padding: 0 !important;">
                  <div class="d-flex">
                      <div style="width: 85px; max-width: 85px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                      </div>
                      <div class="d-flex justify-content-center"
                          style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                          <div class="w-100">
                              <nz-input-group [nzSuffix]="suffixUserInput">
                                  <input nz-input [(ngModel)]="inputUserSignValue"
                                      (input)="onChangeUserSignSearch($event)"
                                      [nzAutocomplete]="autoUserSignSearching"
                                      [ngModelOptions]="{ standalone: true }"
                                      placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}"
                                      #autocompleteInput id="inputUser" />
                                  <nz-autocomplete #autoUserSignSearching>
                                      <nz-auto-option *ngFor="let user of filteredUserOptions"
                                          (selectionChange)="autocompleteUserSignSelected($event, user)"
                                          [nzValue]="''">{{ user.name }}
                                          <span *ngIf="user.email">- {{ user.email }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></nz-auto-option>
                                  </nz-autocomplete>
                              </nz-input-group>
                              <ng-template #suffixUserInput>
                                  <nz-spin *ngIf="nzCheckLoadingUserSign" nzSimple [nzIndicator]="indicatorUserInput">
                                  </nz-spin>
                              </ng-template>
                              <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                      style="font-size: 24px"></i></ng-template>
                          </div>
                      </div>
                  </div>
              </td>
              <td></td>
          </tr>
          </tbody>

        </nz-table>
        <mat-error *ngIf="isValidNoUserExist || isValidExistingSigning" class="font-weight-bold"
                   style="padding-top: 0.5rem">
          {{ "validation.error_user_no_set_up" | translate }}
        </mat-error>
        <!-- </form> -->
      </mat-expansion-panel>
      </div>

      <div class="pl-4 tree-features">
        <div class="font-weight-bold mt-2" style="color: #000000DE;">
          {{'user_group.select_user_allow_use_process' | translate}}
        </div>
        <div style="width: 50% !important; margin-bottom: -1.25rem;"
          class="form-search-tree position-relative">
          <mat-form-field class="mat-full-width">
            <div class="position-absolute" style="top: 9px; left: -22px; cursor: pointer;">
              <mat-icon (click)="searchTree()" class="mr-0" style="font-weight: 900;">search</mat-icon>
            </div>
            <input type="text" #focusInput matInput [formControl]="treeFormControl"
              (keyup.enter)="searchTree()" (focusout)="searchTree()"
              [placeholder]="'user_group.search_tree' | translate" autocomplete="off">
          </mat-form-field>
        </div>

        <ng-container *ngIf="isSearchDataEmpty;else displayTree">
          <p class="text-center mt-2">{{'messages.data_not_found' | translate}}</p>
        </ng-container>

        <ng-template #displayTree>
          <nz-tree nzBlockNode nzCheckable nzMultiple [nzData]="featuresTree"
            [nzExpandedKeys]="defaultExpandedKeys" [nzBeforeDrop]="beforeDrop"
            (nzCheckBoxChange)="onSelectNode($event)" [nzCheckedKeys]="defaultCheckedKeys"
            (nzExpandChange)="expandParentNode($event)" [nzTreeTemplate]="nzTreeTemplate"></nz-tree>

            <ng-template #nzTreeTemplate let-node>
              <span class="w-100" style="max-height: 500px; overflow-y: auto; overflow-x: hidden;">
                <!-- COMPANY -->
                <ng-container
                  *ngIf="node.origin.type === 'COMPANY' || (node.origin.type === 'BRANCH' && enterpriseType === 'BRANCH')">
                  <span *ngIf="node.origin.isActive">
                    <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.5 15.5H0.5V8.5H1.5" stroke="#001737" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M5.5 10.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M5.5 12.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M5.5 8.5H7.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M8.5 3.5V1L15.5 3.5V15.5H3.5V5.5H9.5V15.333" stroke="#001737"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M11.5 12.5V4.5" stroke="#001737" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M13.5 12.5V5.5" stroke="#001737" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span *ngIf="!node.origin.isActive">
                    <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.5 15.5H0.5V8.5H1.5" stroke="#919191" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M5.5 10.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M5.5 12.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M5.5 8.5H7.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M8.5 3.5V1L15.5 3.5V15.5H3.5V5.5H9.5V15.333" stroke="#919191"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M11.5 12.5V4.5" stroke="#919191" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M13.5 12.5V5.5" stroke="#919191" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </span>
                </ng-container>
                <!-- BRANCH -->
                <ng-container *ngIf="node.origin.type === 'BRANCH' && enterpriseType === 'COMPANY'">
                  <span *ngIf="node.origin.isActive">
                    <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2415_1244)">
                        <path d="M14.5 3.5L8 0.5L1.5 3.5" stroke="#001737" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M3.5 2.577V6.5" stroke="#001737" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M12.5 2.577V6.5" stroke="#001737" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M6.5 15.5V11.5H9.5V15.5H15.5V8.5H0.5V15.5H6.5Z" stroke="#001737"
                          stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.5 4.5V5.5" stroke="#001737" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M9.5 4.5V5.5" stroke="#001737" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M3.5 11.5V12.5" stroke="#001737" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M12.5 11.5V12.5" stroke="#001737" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_2415_1244">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span *ngIf="!node.origin.isActive">
                    <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2415_1244)">
                        <path d="M14.5 3.5L8 0.5L1.5 3.5" stroke="#919191" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M3.5 2.577V6.5" stroke="#919191" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M12.5 2.577V6.5" stroke="#919191" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M6.5 15.5V11.5H9.5V15.5H15.5V8.5H0.5V15.5H6.5Z" stroke="#919191"
                          stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.5 4.5V5.5" stroke="#919191" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M9.5 4.5V5.5" stroke="#919191" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M3.5 11.5V12.5" stroke="#919191" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M12.5 11.5V12.5" stroke="#919191" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_2415_1244">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </ng-container>
                <!-- NODE_BETWEEN AND DEPARTMENT -->
                <ng-container
                  *ngIf="node.origin.type === 'NODE_BETWEEN_BRANCH' || node.origin.type === 'NODE_BETWEEN_USER' || node.origin.type === 'DEPARTMENT'">
                  <span *ngIf="node.origin.isActive">
                    <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2415_1105)">
                      <path d="M3.5 7.5V0.5H12.5V5.5" stroke="#001737" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M6.5 9.5H0.5V15.5H6.5V9.5Z" stroke="#001737" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M15.5 7.5H9.5V15.5H15.5V7.5Z" stroke="#001737" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M2.5 12.5H4.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M11.5 10.5H13.5" stroke="#001737" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M11.5 12.5H13.5" stroke="#001737" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M6.5 15.5H9.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6.5 3.5H9.5" stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2415_1105">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  </span>
                  <span *ngIf="!node.origin.isActive">
                    <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                    viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2415_1105)">
                      <path d="M3.5 7.5V0.5H12.5V5.5" stroke="#919191" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M6.5 9.5H0.5V15.5H6.5V9.5Z" stroke="#919191" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M15.5 7.5H9.5V15.5H15.5V7.5Z" stroke="#919191" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M2.5 12.5H4.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M11.5 10.5H13.5" stroke="#919191" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M11.5 12.5H13.5" stroke="#919191" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path d="M6.5 15.5H9.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6.5 3.5H9.5" stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2415_1105">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  </span>
                </ng-container>
                <!-- USER -->
                <ng-container *ngIf="node.origin.type === 'USER'">
                  <span *ngIf="node.origin.isActive">
                    <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M14.5 12.976C14.5002 12.8151 14.4616 12.6566 14.3874 12.5138C14.3132 12.3711 14.2057 12.2483 14.074 12.156C12.2699 10.9877 10.1474 10.409 8 10.5C5.85262 10.409 3.73005 10.9877 1.926 12.156C1.79427 12.2483 1.68677 12.3711 1.61261 12.5138C1.53844 12.6566 1.49982 12.8151 1.5 12.976V15.5H14.5V12.976Z"
                        stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M8 7.5C9.933 7.5 11.5 5.933 11.5 4C11.5 2.067 9.933 0.5 8 0.5C6.067 0.5 4.5 2.067 4.5 4C4.5 5.933 6.067 7.5 8 7.5Z"
                        stroke="#001737" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span *ngIf="!node.origin.isActive">
                    <svg style="display: inline-block; margin-top: -5px;" width="16" height="16"
                      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M14.5 12.976C14.5002 12.8151 14.4616 12.6566 14.3874 12.5138C14.3132 12.3711 14.2057 12.2483 14.074 12.156C12.2699 10.9877 10.1474 10.409 8 10.5C5.85262 10.409 3.73005 10.9877 1.926 12.156C1.79427 12.2483 1.68677 12.3711 1.61261 12.5138C1.53844 12.6566 1.49982 12.8151 1.5 12.976V15.5H14.5V12.976Z"
                        stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M8 7.5C9.933 7.5 11.5 5.933 11.5 4C11.5 2.067 9.933 0.5 8 0.5C6.067 0.5 4.5 2.067 4.5 4C4.5 5.933 6.067 7.5 8 7.5Z"
                        stroke="#919191" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                </ng-container>
                <span matTooltip="{{ node.title }}"
                  [ngClass]="node.origin.isActive ? 'color-text-tree-active font-weight-bold' : 'color-text-tree-inactive font-italic font-weight-normal'"
                  class="position-absolute d-inline-block text-truncate {{node.origin.type === 'TYPE_VIRTUAL' ? 'hide-class' : ''}}"
                  style="margin-left: 10px; width: 85%;">{{ node.title }}</span>
              </span>
            </ng-template>
        </ng-template>
      </div>
      <span style="display: inline-block; color: #333333;" class="pl-2 mt-4 mb-2">
        <span>{{'user_group.note_tree' | translate}}</span>
        <span
          style="color: #919191 !important; font-weight: normal; font-style: italic; padding: 0 5px;">"{{'user_group.branch_department_user'
          | translate}}"</span>
        <span>- {{'user_group.inactive' | translate}}</span>
      </span>

    </mat-accordion>
  </mat-dialog-content>
  </form>

  <mat-dialog-actions align="center">
    <button (click)="onNoClick()" class="mr-3" color="primary" mat-stroked-button type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button (click)="onClickBtnSubmit()" [disabled]="!checkEnableButtonSave() || f.form.invalid" cdkFocusInitial color="primary"
            mat-raised-button
            type="submit">
      <mat-icon class="mr-0">save</mat-icon>
      {{'button.edit_procedure' | translate}}
    </button>
  </mat-dialog-actions>

  <ng-template #contentEmptyTable let-name></ng-template>

